import { useSelector } from 'react-redux';
import { RouteName } from '@mews-commander/enums';
import { ApplicationState } from '@mews-commander/types';
import { useResolveRoute } from '@mews/routing';
import { Dash } from '@mews-commander/ui';
import { getOrderItem } from '@mews-commander/legacy-entities/src/ducks/orderItems';
import { ModalLink } from '../../../components';
import OrderItemName from './OrderItemName';

interface OrderItemLinkProps {
    orderItemId: string;
}

const OrderItemLink = ({ orderItemId }: OrderItemLinkProps) => {
    const orderItem = useSelector((state: ApplicationState) => getOrderItem(state, { id: orderItemId }));
    const resolveRoute = useResolveRoute();

    if (!orderItem) return <Dash />;

    const url = resolveRoute(RouteName.OrderItemActionLog, { id: orderItemId, query: { BillId: orderItem.billId } });

    return (
        <ModalLink data-order-item-link={orderItemId} url={url}>
            <OrderItemName orderItem={orderItem} />
        </ModalLink>
    );
};

export default OrderItemLink;
